
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Timer, Home, BookOpen, BarChart, User } from 'lucide-react';
import { cn } from '@/lib/utils';

export const BottomNav: React.FC = () => {
  const location = useLocation();
  
  const navItems = [
    { icon: Home, path: '/', label: 'Home' },
    { icon: Timer, path: '/timer', label: 'Timer' },
    { icon: BookOpen, path: '/learn', label: 'Learn' },
    { icon: BarChart, path: '/progress', label: 'Progress' },
    { icon: User, path: '/profile', label: 'Profile' },
  ];

  return (
    <div className="fixed bottom-0 w-full border-t bg-background/95 backdrop-blur-sm py-2 z-50">
      <div className="container max-w-md mx-auto">
        <nav className="flex justify-between items-center">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex flex-col items-center px-4 py-2 text-sm transition-all duration-200 rounded-lg",
                location.pathname === item.path
                  ? "text-primary bg-primary/10 scale-105"
                  : "text-muted-foreground hover:text-foreground hover:bg-accent/50 hover:scale-105"
              )}
            >
              <item.icon size={20} className="mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};
